import { useLocales } from '@shared/locales'
import { Checkbox, Form, Input } from 'antd'

export const FormNomenclaturesCurrencies = () => {
  const { t } = useLocales()

  return (
    <>
      <Form.Item
        name="name"
        label={t('nomenclature.name')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="symbol"
        label={t('nomenclature.symbol')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item name="ratio" label={t('nomenclature.ratio')}>
        <Input type="number" step="0.001" />
      </Form.Item>

      <Form.Item name="is_default" valuePropName="checked">
        <Checkbox>{t('nomenclature.set_as_default')}</Checkbox>
      </Form.Item>
    </>
  )
}
